import React from "react";

class PreviewErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error) {
    // Keep console visibility in development while isolating preview failures.
    // eslint-disable-next-line no-console
    console.error("Preview runtime error:", error);
  }

  render() {
    const { componentTitle, scenarioId, wrapper } = this.props;
    if (this.state.hasError) {
      return (
        <div className="rounded-lg border border-rose-200 bg-rose-50 p-4 text-sm text-rose-900">
          <p className="font-semibold">Preview-feil</p>
          <p className="mt-2">
            Komponent: <span className="font-medium">{componentTitle}</span>
          </p>
          <p>
            Scenario: <span className="font-medium">{scenarioId}</span>
          </p>
          <p>
            Wrapper: <span className="font-medium">{wrapper}</span>
          </p>
          <p className="mt-2 text-xs text-rose-700">
            {this.state.error?.message || "Ukjent feil i preview-runtime."}
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default PreviewErrorBoundary;
